import React, { useContext, Fragment, useMemo } from 'react';
import './Grid.module.scss';

// Import components
import Card from './Card/Card';

// Import types & context
import { FilterOptions, HomeContext } from '../Home';

export interface Block {
  content: {
    title: string;
    paragraph?: string;
  };
  size: {
    column: number;
    row: number;
  };
  background?: string;
  backgroundPattern?: string;
  categories?: FilterOptions[];
}

export default function Grid() {
  const { activeFilters, data } = useContext(HomeContext);

  const shuffeledArray = data
    .map((item) => ({ item, sort: Math.random() }))
    .sort((a, b) => a.sort - b.sort)
    .map(({ item }) => item);

  // function getRndInteger(min: number, max: number) {
  //   return Math.floor(Math.random() * (max - min)) + min;
  // }

  function getFilteredArray() {
    if (activeFilters.length === 0) {
      return shuffeledArray;
    }
    const filteredArray = shuffeledArray.filter((element) => {
      if (element.categories) {
        const categoryIds = element.categories.map((item) => item.id);
        const found = categoryIds.some((r) => activeFilters.includes(r));
        return found;
      }
      return false;
    });
    return filteredArray;
  }

  const blocks = useMemo(getFilteredArray, [activeFilters, data.length]);

  return (
    <div styleName="grid">
      {blocks.map((item, i) => (
        <Fragment key={i}>
          <Card index={i} item={item} />
          {/* Render a empty div sometimes */}
          {/* {i % getRndInteger(2, 4) === 0 && <div styleName="item invisible" />} */}
        </Fragment>
      ))}
    </div>
  );
}
